module.exports = __webpack_public_path__ + "static/line-bot-transcripts-7651fb2dfc12895aa71089cff8dae968.png";